import { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import RepricerService from '@/plugins/api-plugin/services/repricer.service'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'
import { RepricerLogDetailDao } from '@/interfaces/repricer/RepricerLogPage.dao'
import RepricerSalesChannelsLogsDao from '@/interfaces/repricer/RepricerSalesChannelsLogs.dao'

type LogPage = [RepricerLogDetailDao[], PageNumberPagination]

/**
 * A cDiscount log in the shape of an Amazon log, so the same pages read both. Our price on the
 * channel is the listing price and `PriceChange` the new one; the rule, the action, the FOEP and
 * the review time are not stored for cDiscount.
 */
export const cdiscountLog = (row: RepricerSalesChannelsLogsDao): RepricerLogDetailDao => ({
    ...row,
    RepricerAction_Id: null,
    RepricerException_Id: null,
    FeaturedPrice: null,
    ActionSetAt: null,
    ListingPrice: row.CurrentLuzernPrice,
    LuzernPriceChange: row.PriceChange,
})

const cdiscountPage = (page: unknown): LogPage => {
    const [rows, meta] = page as [RepricerSalesChannelsLogsDao[], PageNumberPagination]
    return [rows.map(cdiscountLog), meta]
}

/** The repricer API of the cDiscount logs (`RepricerSalesChannelsLogs`): the sales-channel endpoints. */
export default class RepricerCdiscountService extends RepricerService {
    protected override readonly logsPath = '/repricer/repricer-sales-channels-logs'

    protected override readonly listingPath = '/repricer/repricer-sales-channels-listing'

    protected override readonly listingStagesPath = '/repricer/sales-channels-listing-stages'

    protected override readonly actionSuffix = '-sales-channels'

    override async logsList(params: IRequestParameters): Promise<LogPage> {
        return cdiscountPage(await super.logsList(params))
    }

    override async logsExport(params: IRequestParameters): Promise<LogPage> {
        return cdiscountPage(await super.logsExport(params))
    }

    override async logPageLog(id: number): Promise<RepricerLogDetailDao | null> {
        const row = (await super.logPageLog(id)) as unknown as RepricerSalesChannelsLogsDao | null
        return row ? cdiscountLog(row) : null
    }

    override async logPageAround(params: IRequestParameters): Promise<LogPage | null> {
        const page = await super.logPageAround(params)
        return page ? cdiscountPage(page) : null
    }
}
